/* import __COLOCATED_TEMPLATE__ from './grouped-badges.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();